import * as React from "react";
const SvgFlag = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12.047, height: 22.373, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 5.593v16.78h.861V9.957l11.186-4.794L0 0v5.593z", "data-name": "flag", fill: "currentColor", fillRule: "evenodd" }));
export default SvgFlag;
